'use client'
import React from 'react'
import { DropdownIcon } from '../../../icons'
import { DropdownIndicatorProps } from 'react-select'
import { SelectOption } from '../../../../types/SelectInput'

export const DropdownIndicatorReplacement = (props: DropdownIndicatorProps<SelectOption>) => {
    return (
        <span
            {...props.innerProps}
            className="w-10 h-full inline-flex items-center justify-center text-accent-700 border-transparent hover:bg-accent-opacity-100 active:bg-accent-opacity-100 active:shadow-inner-md focus:bg-accent-opacity-100 focus:border-accent-600 cursor-pointer"
            data-testid="select-input-dropdown-button"
        >
            <DropdownIcon />
        </span>
    )
}
